module.exports = "li {\r\n    font-size: 20px;\r\n    font-weight: 550;\r\n}\r\n\r\nh1 {\r\n    text-align: center;\r\n    font-size: 50px;\r\n}\r\n\r\n.startBtn {\r\n    margin: 3em 10em;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/blackjackhome/blackjackhome.component.css
// module id = ./src/app/blackjackhome/blackjackhome.component.css
// module chunks = main